import { render } from "./ObjectivesListingSettingsHeader.vue?vue&type=template&id=fe2cf75e"
import script from "./ObjectivesListingSettingsHeader.vue?vue&type=script&lang=js"
export * from "./ObjectivesListingSettingsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__